import React from "react";
import { View, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { StatusConfig } from "./types";

type StatusIconProps = {
  config: StatusConfig;
  compact?: boolean;
};

export function StatusIcon({ config, compact = false }: StatusIconProps) {
  return (
    <View style={[styles.statusIcon, { backgroundColor: config.color }]}>
      <MaterialCommunityIcons name={config.icon} size={compact ? 12 : 14} color="white" />
    </View>
  );
}

const styles = StyleSheet.create({
  statusIcon: {
    width: 20,
    height: 20,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
  },
});
